export default {
  maintenance: "Site-ul este în mentenanță. Revenim in câteva momente!",
  maintenance_phone: "Aplicatia este în mentenanță. Revenim in câteva momente!",

  //General phrases
  tollWord: "Taxă pod Fetești | Taxe pod Fetești | Peaje",
  vignetteWord: "Rovinietă | Roviniete",

  site_tpf: "taxa-pod-fetesti.ro",
  site_erv: "e-rovinieta.ro",

  currency: "leu | lei",
  category: "categoria",
  select_type_of_vehicle: "Selectează tipul vehiculului",
  select_the_period: "Alege perioada",
  or_pay_for: "Sau achită pentru",
  your_vehicles_link: "autovehiculele tale",
  or_go_to_your_account_and_buy:
    "Intră în cont și cumpără pentru vehiculele tale",
  see_cart: "Vezi coșul",
  or: "sau",
  and: "și",
  back: "înapoi",
  total: "Total",
  total_sms: "Total SMS",
  pf: "Persoană fizică",
  pj: "Persoană juridică",
  yes: "Da",
  no: "Nu",
  about: "Despre",
  us: "noi",

  vignette: "rovinietă | roviniete",
  passing: "trecere | treceri",

  toll_buy: "Achită taxă pod",
  vignette_buy: "Achită rovinietă",
  insurance_buy: "Achită asigurare",

  //Order
  billing_add_new_profile: "Adaugă profil nou de facturare",

  cart_empty: "Coșul este gol",
  cart_available_from: "valabilă din",
  cart_add_more: "Continuă să adaugi în coș alte",
  cart_continue_with_buying: "Mai cumpară",
  cart_validation_errors:
    "Produse scoase din comandă din cauza erorilor de validare",

  order_container_place_order_title: "Plasează comanda",
  order_container_my_cart: "Coșul meu",
  order_container_billing_info: "Facturare",
  order_container_payment: "Plată",

  payment_method_insuficient_credit: "credit insuficient",
  payment_method_insuficient_debit: "debit insuficient",
  payment_method_instant_credit: "Credit instant",
  payment_method_instant_credit_description: "Credit instant",
  payment_method_credit_card: "Online cu card bancar",
  payment_method_credit_card_description: "Plata va fi procesată prin PayU.ro",
  payment_method_iTransfer_description: "Ordin de plată cu confirmare imediată",
  payment_method_payment_order: "Ordin de plată",
  payment_method_payment_order_description:
    "Vei primi pe email proforma aferentă achiziției, conținând dispozițiile de plată. Comanda va fi emisă în momentul recepționării plății",
  payment_method_credit_erv: "Credit e-rovinietă",
  payment_method_debit_erv: "Debit e-rovinietă",
  payment_method_credit_tpf: "Credit taxă pod fetești",
  payment_method_debit_tpf: "Debit taxă pod fetești",
  payment_method_terms:
    "Confirm că datele de mai sus sunt corecte și că am citit și sunt de acord cu",
  payment_method_op_not_available_during_weekend:
    "Nu se poate plati cu OP de joi 16:30 PM pana duminica 23:59 PM.",
  payment_method_op_not_available_last_day_of_month:
    "Nu se poate plati cu OP in ultima zi din lună",

  thank_you_placed_order_title: "Comanda dvs a fost plasată",
  thank_you_successful_order:
    "Comanda a fost plasată cu succes. Vezi statusul ei în comenzile tale.",
  thank_you_successful_order_not_loggedin:
    "Comanda a fost plasată cu succes. Factura cu rovinieta emisă îți va fi trimisă pe e-mail.",
  thank_you_see_info_order:
    "Nu pleca la drum înainte de a primi rovinieta prin email sau datele ei prin SMS, altfel risti sa fii amendat!",
  thank_you_see_info_order_not_loggedin:
    "Nu pleca la drum înainte de a verifica dacă ai primit rovinieta(email sau sms), altfel risti sa fii amendat!",
  thank_you_my_orders: "Detalii comandă",
  thank_you_extra_info_not_loggedin:
    "Creează un cont și salvează datele pentru comenzi viitoare",

  thank_you_itransfer_or_debit_card_or_instant_credit:
    "Va rugam sa asteptati factura fiscala! Vă mulțumim pentru plata efectuată. În cel mai scurt timp veți primi pe email confirmarea emiterii comenzii dvs. Vã rugãm sã nu plecați la drum pânã când nu primiți confirmarea emiterii.",
  thank_you_op_payment:
    "Vă mulțumim pentru comanda dvs. V-am trimis pe email factura proformã, vã rugãm sã o achitați în conturile menționate în document și sã ne transmiteți OP la adresa contact@e-rovinieta.ro",

  //Account
  continue_with: "Continuă cu",
  continue: "Continuă",
  account_activate_header: "Activează contul",
  account_activate_message: "",

  account_container_my_account: "Contul meu",
  account_container_vehicles: "Vehicule",
  account_container_orders: "Comenzi",
  account_container_profiles: "Profile facturare",
  account_container_info: "Date cont",
  account_container_cards: "Carduri",

  account_data_title: "Detalii cont",

  add_car_title: "Adăugare autovehicul",

  edit_car_no_vehicles: "Niciun vehicul găsit!",
  edit_car_delete_vehicle_title: "Șterge vehicul",
  edit_car_delete_vehicle: "Ești sigur că vrei să ștergi acest vehicul?",

  delete_product_title: "Șterge produs",
  delete_product: "Ești sigur că vrei să ștergi acest produs?",

  add_profile_title: "Adăugare profil",
  add_profile_pj_extracted: "Date persoană juridică extrase automat",

  edit_profile_title: "Modificare profil",
  edit_profile_delete_profile_title: "Șterge profil",
  edit_profile_delete_profile: "Ești sigur că vrei să ștergi acest profil?",

  my_orders_passings: "o trecere | {count} treceri",

  profiles_main: "Principal",
  profiles_secondary: "Secundar",
  profiles_unverified_data: "Date neverificate",
  profiles_no_profile: "Nu există niciun profil",
  profiles_delete_profile: "Șterge profil",
  profiles_are_you_sure: "Ești sigur că vrei să ștergi profilul?",

  search_car_button: "Caută",
  search_car_after_license_plate: "Caută după număr",

  //Authentication
  login_auth: "Autentificare",
  login_login_into_your_account: "Intră în contul tău",

  login_component_login_by: "Login cu",
  login_component_no_account: "Nu ai cont?",
  login_component_forgot_password: "Ai uitat parola?",

  new_account_title: "Înregistrează-te",
  new_account_details: "Detalii cont",
  new_account_ive_read: "Am citit și sunt de acord cu",
  new_account_tc: "Termenii și condițiile",
  new_account_site: "site-ului",
  mandatory: "Obligatoriu",
  new_account_pc: "Politica de confidențialitate",
  new_account_must_accept_tc:
    "Trebuie să accepți termenii și condițiile și politica de confidențialitate",
  new_account_must_accept_pc:
    "Trebuie să accepți politica de confidențialitate",

  contact_title: "Contact",

  faq_title: "Întrebări frecvente",

  header_how_does_it_work: "Cum funcționează?",

  how_it_works_p1: "Pornești la drum în 3 minute!",
  how_it_works_p2: "Distribuitor autorizat CNAIR",
  how_it_works_p3: "Comandă online cu taxa-pod-fetesti.ro",

  toll_category_error_loading_car: "Problemă la încărcarea mașinii",
  toll_category_error_loading_country: "Problemă la încărcarea țărilor",

  vignette_category_error_fromdate:
    "Alege data când va intra în vigoare rovinieta",
  vignette_category_chasis_warning_msg:
    "Pentru rovinietele de 1 zi nu este obligatorie seria de sașiu",
  vignette_category_chasis_warning_msg_7:
    "Pentru rovinietele de 7 zile nu este obligatorie seria de sașiu",

  reset_password_title: "Resetează parola",
  reset_password_label: "Introdu emailul",

  reset_password_update_title: "Salvează noua parolă",

  //Buttons
  btn_save: "Salvează",
  btn_save_changes: "Salvează modificările",
  btn_add_car: "Adaugă vehicul",
  btn_delete_car: "Șterge vehiculul",
  btn_next_step: "Pasul următor",
  btn_finish: "Finalizează comanda",
  btn_grab_data_company: "Preia date<br/> Registrul Comerțului",
  btn_add_profile: "Adaugă profil nou",
  btn_i_understand: "Am înțeles",
  btn_login: "Login",
  btn_register: "Înregistrează-te",
  btn_create_account: "Creează cont",
  btn_add_to_cart: "Adaugă în cos",
  btn_edit_to_cart: "Modifică produs",
  btn_reset_password: "Resetează parola",
  btn_bill: "Facturează",
  btn_choose_payment_method: "Alege metoda de plată",
  btn_send: "Trimite mesaj",

  //Labels
  label_category: "Categorie",
  label_choose_category_contact: "Alege categorie",
  label_message: "Mesaj",
  label_email: "Email",
  label_password: "Parolă",
  label_confirm_password: "Confirmă parola",
  label_phone: "Telefon",
  label_license_plate: "Număr înmatriculare",
  label_chasis_number: "Serie de șasiu",
  label_registration_country: "Țară înmatriculare",
  label_motif: "Motiv categorie inferioară",
  label_choose_category: "Alege categoria pentru",
  label_billing_type: "Facturare pe",
  label_last_name: "Prenume",
  label_first_name: "Nume",
  label_country: "Țară",
  label_county: "Județ",
  label_city: "Oraș",
  label_address: "Adresă",
  label_cui: "CUI",
  label_reg_com: "Registrul comerțului",
  label_locality: "Localitate",
  label_company_name: "Nume companie",
  label_for_car: "Pentru autovehiculul",
  label_available_from: "Valabilă de la data",
  label_optional_field: "opțional",

  //terms
  terms: "Termeni și condiții",
  partners: "Parteneri",
  distribution: "Puncte de distribuție",
  legislative_info: "Informații legislative",

  //menu pages
  how_it_works: "Cum funcționează",
  info: "Informatii legislative",
  for_companies: "Pentru companii",
  distribution_untrr: "Listă puncte de distribuție UNTRR",
  about_us: "Despre noi",
  cookies: "Cookies",

  //footer
  footer_new_account_link: "Vino alături de profesioniști",

  sms_confirm_notification_peaj:
    "Vreau sa primesc SMS la confirmarea emiterii taxei de pod Fetești (GRATIS) | Vreau sa primesc SMS la confirmarea emiterii taxei de pod Fetești (+{price}) | Vreau sa primesc SMS la confirmarea emiterii taxei de pod Fetești (+{price})",

  sms_confirm_notification:
    "Vreau sa primesc SMS la confirmarea emiterii rovinietei (GRATIS) | Vreau sa primesc SMS la confirmarea emiterii rovinietei (+{price}) | Vreau sa primesc SMS la confirmarea emiterii rovinietei (+{price})",
  sms_expiry_notification:
    "Vreau sa primesc SMS inainte de expirarea rovinietei (GRATIS) | Vreau sa primesc SMS inainte de expirarea rovinietei (+{price}) | Vreau sa primesc SMS inainte de expirarea rovinietei (+{price})",
  sms_notification_confirmation:
    "Cu notificare SMS la confirmare (GRATIS) | Cu notificare SMS la confirmare (+{price}) | Cu notificare SMS la confirmare (+{price})",
  sms_notification_expiry:
    "Cu notificare SMS inainte de expirare (GRATIS) | Cu notificare SMS inainte de expirare (+{price}) | Cu notificare SMS la expirare (+{price})",
  cnair_expiry_notification:
    "Vreau sa primesc email de la CNAIR inainte de expirarea rovinietei",
  cnair_notification_expiry:
    "Cu notificare pe email de la CNAIR inainte de expirare",

  //New terms
  btn_edit: "Modifică",
  btn_edit_password: "Modifică parola",
  btn_edit_phone: "Modifică telefon",
  btn_delete_account: "Şterge contul",
  btn_import_csv: "Importă csv",
  btn_export_csv: "Exportă csv",

  //account
  data_saved_succesfully: "Date salvate cu succces",
  invalid_plate_number_message: "Numărul nu are formatul corect",
  invalid: "Nevalid",
  countries_loading: "Problemă la încărcarea țărilor",
  tpf_categories_loading:
    "Problemă la încărcarea categoriilor de taxă pod fetești",
  erv_categories_loading: "Problemă la încărcarea categoriilor de rovinietă",
  csv_header:
    '"Număr","Șasiu","Categorie rovinietă","Categorie taxă pod fetești","Țară"',
  order_header_name: "Nume",
  date: "Dată",
  order_header_payment_type: "Tip plată",
  order_header_status: "Status",
  no_placed_order: "Nu există nicio comandă plasată.",
  i_want: "Vreau",
  no_order: "Comanda nu a putut fi găsită.",
  delete_request_sent_message: "Cerere de ștergere cont trimisă",
  delete_request_already_sent_message: "Cererea a fost deja trimisă",

  product_status: "Status",
  product_payment_method: "Metoda de plată",
  product_bill_data: "Date facturare",
  product_valability: "Valabilitate",

  download_bill: "Descarcă factura",
  download_client_copy: "Descarcă copie client",
  download_bill_sms: "Descarcă factura SMS",
  vignette_series: "Serie rovinietă",
  toll_series: "Serie peaj",

  //authentication
  login_account: "Intră în cont",
  already_have_account: "Ai deja un cont?",
  password: "Parola",
  password_confirm: "Repetă parola",
  return_to_login_1: "Întoarce-te în pagina de",
  return_to_login_2: "Login",

  // order
  order_title: "Detaliile comenzii tale cu ID #",
  choose_profile: "Alege un profil",
  order_step4: "Pasul 4: Facturare",
  login_to_your_account: "Intră în contul tău",
  login_to_your_account_2: "și alege datele de facturare deja salvate.",
  order_without_account:
    "Poți plasa comanda fără cont completând datele de mai jos",
  fill_all_fields: "Completează toate câmpurile obligatorii",
  order_address_info: "La această adresă vei primi factura și rovinieta",
  invalid_profile_msg: "Acest profil nu este valid",
  delete_profile_msg: "Șterge profil",
  delete_profile_confirm: "Ești sigur că vrei să ștergi profilul ?",
  invalid_email: "Email nevalid",
  invalid_tel: "Telefon nevalid",
  mandatory_city: "Orașul este obligatoriu",
  mandatory_first_name: "Prenumele este obligatoriu",
  mandatory_last_name: "Numele este obligatoriu",
  mandatory_country: "Județul este obligatoriu",
  mandatory_fiscal_code: "CUI-ul este obligatoriu",
  mandatory_j_code: "Registrul comerțului este obligatoriu",
  mandatory_company: "Compania este obligatorie",
  mandatory_address: "Adresa este obligatorie",
  my_shopping_cart: "Coșul meu",
  order_step3: "Pasul 3: Sumar",
  buy_vignette_or_bridge_fee: "Poți cumpăra rovinietă sau taxă de pod Fetești",
  order_step5: "Pasul 5: Plata",
  warning: "ATENȚIE!",
  warning_txt_1:
    "Pentru achitarea rovinietelor prin ordin de platã, comanda va fi aprobatã dupã încasarea banilor în contul bancar al UNTRR.",
  warning_txt_2:
    "Rovinietele achitate cu ordin de platã se emit de luni pânã vineri în intervalul 08:00 – 16:30.",
  warning_txt_3:
    "Nu plecați la drum până când nu primiți confirmarea de emitere a rovinietei.",
  warning_txt_4:
    "UNTRR nu este responsabilă pentru nerespectarea condițiilor de mai sus!",
  choose_card: "Alege unul din cardurile tale salvate",
  new_card: "Card nou",
  add_card_for_next_transactions:
    "Adaugă cardul în contul meu pentru cumpărături viitoare",

  free: "Gratuit",
  btn_logout: "Log out",

  frequent_questions_heading: "Întrebări și răspunsuri frecvente",
  see_all_frequent_questions: "Vezi toate întrebările și răspunsurile",

  step: "Pasul {n}",
  choose_passings_number: "Alege număr treceri",

  juridical_person: "Persoană juridică",
  individual_person: "Persoană fizică",
  auto_query_company_data: "Îți preluăm automat datele firmei",
  verified_company_data: "Date companie verificate!",
  unverified_company_data: "Date companie neverificate",
  unverified_company_data_with_manual_completion:
    "Verificare automată indisponibilă, vă rugăm completați câmpurile manual",
  check_vignette_valability: "Verifică valabilitate rovinietă",
  resources: "Resurse",
  i_want_vignette: "Vreau rovinietă",
  i_want_toll: "Vreau taxă pod Fetești",
  i_want_insurance: "Vreau asigurare",
  vehicle_type: "Tip vehicul",
  period: "Perioadă",
  summary: "Sumar",
  billing: "Facturare",
  payment: "Plată",
  you_have_multiple_usernames:
    "Aveți <b>{count}</b> conturi asociate cu acest email.",
  choose_login_account: "Alegeți contul cu care doriți să vă autentificați",

  //benefits page
  bp_heading: "În plus",
  bp_company_advantages: "Avantaje pentru companii",
  bp_one_account_multiple_advantages: "Un singur cont, mai multe beneficii",
  bp_contact_us_for_personalized_solution:
    "Contactați-ne pentru o soluție personalizată",
  bp_online_emission: "Emitere online 24/7",
  bp_online_assistance:
    "Aveți asistență online și puteți cumpăra rovinieta sau taxa de pod Fetești 24/7",
  bp_import_your_cars: "Importați tot parcul auto",
  bp_import_you_cars_through_excel:
    "Importați la noi tot parcul auto al firmei, pe baza unui fișier excel.",
  bp_multiple_profiles: "Mai multe profiluri",
  bp_multiple_profiles_for_same_email:
    "Aveți posibilitatea de a crea mai multe profiluri pentru toți utilizatorii firmei, cu aceeași adresă de email.",
  bp_vignettes_status: "Status roviniete",
  bp_verify_vignette_status:
    "Pe site puteți verifica oricând statusul rovinietelor emise.",
  bp_orders_history: "Istoric comenzi",
  bp_orders_history_description:
    "În cadrul contului puteți regăsi toate comenzile plasate și facturile.",
  bp_multiple_orders: "Comenzi multiple",
  bp_multiple_orders_description:
    "Puteți adăuga mai multe roviniete în coș și plasa comenzi multiple.",
  bp_email_sms_confirmation: "Confirmare prin email și SMS",
  bp_email_sms_confirmation_description:
    "Primiți confirmare de emitere a rovinietei prin email și SMS.",
  bp_expiry_alerts: "Alerte de expirare",
  bp_expiry_alerts_description:
    "Pentru rovinietele pentru rovinietele de și peste 30 de zile vă avertizăm prin email înainte să expire.",
  bp_need_help: "Aveți nevoie de ajutor?",
  bp_call_operators:
    "Apelați unul dintre operatorii noștri pentru asistență în emiterea rovinietelor. Serviciul este disponibil de luni până vineri (exceptând sărbătorile legale), între orele 08:00 - 17:00.",
  bp_offices: "Listă reprezentanțe",
  bp_have_cars: "Dețineți o flotă de autovehicule?",
  bp_contact_us_for_personalized_solution_for_your_bussiness:
    "Contactați-ne pentru a vă oferi o soluție personalizată pentru afacerea dumneavoastră.",
  bp_contact_us_now: "Contactați-ne acum",

  //contact
  contact_viggnete_emission: "Emitere de roviniete",
  contact_agencies: "Agenții",
  contact_see_all_agencies: "Vezi toate agențiile regionale",
  contact_see_all_agencies_continuation: "de unde poți lua roviniete.",
  message_sent_successfully:
    "Mesaj trimis cu succes! Vă vom contacta la email-ul specificat în cel mai scurt timp posibil!",
  message_sent_error:
    "Am întampinat o problema cu trimiterea mesajului. Va rugăm reveniți mai târziu!",
  category_1: "Valabilitate rovinietă",
  category_2: "Comenzi",
  category_3: "Plată rovinietă",
  category_4: "Oferte companii",
  category_5: "Alte informații",

  //distribution
  distribution_header:
    "LISTA PUNCTELOR DE LUCRU APARȚINÂND UNTRR ABILITATE SĂ ÎNCASEZE TARIFUL DE UTILIZARE A REȚELEI DE DRUMURI NAȚIONALE DIN ROMÂNIA (ROVINIETA)",
  distribution_nr_crt: "Nr. crt.",
  distribution_work_point: "Punct de lucru",
  distribution_terminals_and_portals: "TERMINALE ȘI PORTALURI WEB",
  distribution_name: "Denumire",
  distribution_terminals: "Terminale ZEBRAPAY",
  distribution_location_terminal_details: "Detalii locații terminale ZEBRAPAY",
  distribution_untrr_portal: "PORTAL UNTRR",

  //footer
  footer_copyright:
    "Toate drepturile rezervate 2010 - {currentYear} @ Uniunea Naţională a Transportatorilor Rutieri din România.",

  //homepage
  homepage_authorized_distributor: "Distribuitor autorizat C.N.A.I.R",
  homepage_buy_tpf_erv: "Cumpără rovinietă sau taxă de pod Fetești",
  homepage_ready_for_road: "Gata de drum imediat",
  homepage_order: "Comandă",
  homepage_payment: "Plătește",
  homepage_drive: "Circulă",
  homepage_your_advantages: "Avantajele tale",
  homepage_vignette_availability: "Verifici valabilitate rovinietă",
  homepage_vignette_availability_description_1:
    "Nu știi dacă ai rovinieta valabilă? Evită amenda.",
  homepage_vignette_availability_description_2: "Verifică valabilitatea aici",
  homepage_save_data: "Salvează datele",
  homepage_save_data_description:
    "Iți faci cont, salvezi datele mașinii, și cumperi rovinieta și taxa pod Fetești într-un singur loc.",
  homepage_sms_email_delivery: "Livrare prin email și SMS",
  homepage_sms_email_delivery_description: "Livrare prin email și SMS",
  homepage_card_or_op: "Achiți prin card sau OP",
  homepage_card_or_op_description:
    "Achiziție rapidă și sigură prin card bancar sau ordin de plată.",
  homepage_notify_expiry: "Notificare expirare",
  homepage_notify_expiry_description:
    "Pentru rovinietele pe o perioadă mai mare de 30 de zile te avertizăm înainte să expire.",
  homepage_professional_services: "Servicii profesioniste",
  homepage_professional_services_description:
    "De la profesioniștii în transporturi pentru toți utilizatorii rețelei de drumuri din România.",
  homepage_online_assistance:
    "În plus, ai asistență online și beneficiezi de o soluție personalizată pentru nevoile firmei tale.",
  homepage_discover_all_benefits: "Descoperă toate beneficiile",
  homepage_distribution_points: "Puncte distribuție",
  homepage_authorized_distributor_2:
    "UNTRR este distribuitor autorizat de C.N.A.I.R. pentru emitere de roviniete electronice cu prezență în mediul online şi cu puncte teritoriale.",
  homepage_distribution_points_description:
    "Vezi lista de puncte de distribuție",
  homepage_frequent_questions: "Întrebări și răspunsuri frecvente",
  homepage_frequent_questions_description:
    "Vezi toate întrebările și răspunsurile",

  //info
  info_download_file: "Descarcă fisier",

  //reset
  reset_cart: "Cartul a fost resetat.",

  buy_vignette: "Cumpără rovinietă",
  buy_toll: "Cumpără taxă de pod Fetești",

  no_saved_credit_card: "Nu aveți niciun card salvat!",
  card_delete_title: "Șterge cardul",
  card_delete_body: "Ești sigur că vrei să ștergi cardul?",

  //verify vignette
  verify_vignette_title: "Verifică rovinietă",
  heel_series: "Serie talon",
  heel_number: "Număr talon",
  request_verify_vignette: "Solicită verificare la CNAIR",
  btn_verify: "Verifică",
  vignette_available_until: "Rovinietă valabilă până la ",
  error: "S-a produs o eroare cu cererea, vă rugăm să reveniți mai târziu.",
  you_will_be_contacted:
    "Operatorii UNTRR vor verifica stadiul rovinietei tale și vor reveni cu un răspuns în intervalul 08:00 - 17:00.",

  //cars
  show_all_vehicles: "Afișează toate vehiculele",
  show_only_active_vignette_vehicles: "Roviniete active",
  show_only_expired_vignette_vehicles: "Roviniete expirate",

  sort_by_car_name: "Număr înmatriculare alfabetic",
  sort_vignette_expiry: "Expirare rovinietă",

  //peaj
  vehicles: "Autoturisme",

  //vehicles
  active: "Activă până pe ",
  expired: "Expirată",
  unknown: "Necunoscut",
  vignette_status: "Stare rovinietă",
  btn_show_more_info: "Afișează informații import",
  btn_show_less_info: "Ascunde informații import",
  imported_vehicles:
    "A fost importat {vehicles} vehicul | Au fost importate {vehicles} vehicle",

  //orders
  choose_status: "Alege status",
  continue_payment: "Continuă plata",

  overlapping_products: "Acest produs se suprapune cu un alt produs din cos",
  aleady_active_vignette:
    "Există deja o rovinietă activă până pe {date} pentru aceasta mașină.",

  Zi_1: "1 zi",
  Zi_7: "7 zile",
  Zi_10: "10 zile",
  Zi_60: "60 de zile",
  Zi_30: "30 de zile",
  Zi_90: "90 de zile",
  Luna_12: "12 luni",
  days: "o zi | {count} zile",
  months: "o lună | {count} luni",

  see_all_your_vehicles: "Vezi toate vehiculele tale",
  here: "aici",

  fill_in_tpf_category: "Completează cat. TPF",
  fill_in_erv_category: "Completează cat. Rovinietă",

  chasis_number_warning: "Seria de sașiu este obligatorie pentru rovinietele de {label}",

  please_check_informations:
    "Vă rugăm să verificați corectitudinea numărului de înmatriculare introdus, înainte de a continua spre modalitatea de plata. Vă mulțumim!",

  sort_by: "Ordonează dupa",
  type: "Tip",

  payment_method_instant_debit: "Debit instant",
  payment_method_instant_debit_description:
    "Vei achita din suma alocata contului",

  new_app_version_android:
    "Versiune noua de aplicatie in market, te rugam sa updatezi aplicatia!",
  new_app_version_ios:
    "Versiune noua de aplicatie in appstore, te rugam sa updatezi aplicatia!",

  sms_notice: `
    <strong>Serviciul contra cost de notificare prin SMS</strong><br/><br/> 
    Serviciul de notificare prin mesaje scurte (SMS) permite notificarea clientilor www.e-rovinieta.ro pentru confirmarea emiterii rovinietelor sau peajelor si expirarea rovinietelor. 
    Serviciul este optional, contra cost, la alegerea clientilor si este valabil doar pentru comenzile achitate online prin procesatorul de plati (PayU).<br/><br/> 
    Notificarea este posibila doar pentru utilizatorii retelelor mobile nationale.<br/><br/>
    Notificarea prin sms pentru confirmarea rovinietei/peajului se face instant de la finalizarea comenzii iar notificarea prin sms pentru expirarea rovinietei se face cu 7 zile inainte de expirarea rovinietei.<br/><br/>
    Corectitudinea datelor si informatiilor din SMS despre emiterea rovinietei/peajului, numarul de inmatriculare, seria de sasiu si a numarului de telefon mobil, introduse in platforma www.e-rovineta.ro sunt strict in responsabilitatea utilizatorului.<br/><br/> 
    Notificarea prin SMS este realizata prin NETOPIA Payments.<br/><br/> 
    Sistemul de notificare SMS trimite notificari clientilor care opteaza pentru acest serviciu.<br/><br/> 
    Primirea SMS-urilor  poate fi afectata de functionarea si zonele de acoperire ale retelelor de telecomunicatie, de functionarea dispozitivelor utilizate, nefunctionalitatea sistemelor informatice. etc.<br/><br/> 
    Pentru sesizari, situatii in care nu primiti sms,  va rugam sa folositi pagina de <a href="https://www.e-rovinieta.ro/ro/contact">contact</a> a site-ului.<br/><br/>
    U.N.T.R.R. nu poate fi responsabil pentru daune de orice fel pe care utilizatorul sau oricare terta parte o poate suferi ca rezultat al neprimirii sms-ului.<br/><br/>
  `,

  start_valability: 'De la ',
  end_valability: 'Pana la',
  btn_report_emitted: 'Genereaza raport {type} emise',
  btn_export_all_orders: 'Exporta toate comenzile',
  no_reponse_data: 'Nu exista {type} in acest interval',

  captch_error_msg: 'Verificare reCaptcha esuata, te rugam sa incerci din nou',

  homepage_partners: 'Site-uri partenere'
};
